import { z } from 'zod';

export type SignupFields = {
  email: string;
  phone?: string;
  password: string;
  firstName: string;
  lastName: string;
};

export const SignUpSchema = z.object({
  firstName: z.string().min(3, 'At least 3 characters').max(15, 'Max 15 characters'),
  lastName: z.string().min(3, 'At least 3 characters').max(15, 'Max 15 characters'),
  email: z
    .string()
    .email()
    .transform(value => value?.toLowerCase()),
  phone: z
    .string()
    .regex(/[0-9,+]{10,}/)
    .min(9)
    .max(16)
    .optional(),
  password: z.string().min(8, 'At least 8 characters').max(100, 'Max 100 characters'),
});

export type SignUpSchemaType = z.infer<typeof SignUpSchema>;
export type ErrorMessage = { message: string };
